import styles from './KeyElements.module.scss'
import { useRef } from 'react'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

interface KeyElementsProps {
  KeyElementsItems: KeyElementsItem[]
}

export interface KeyElementsItem {
  title: string
  description: string
  src: string
}

const KeyElements: React.FC<KeyElementsProps> = (props) => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  return (
    <section
      className={`${styles.container} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <h2 className={styles.sectionTitle}>デザインシステムの構成要素</h2>
      <p className={styles.sectionRead}>
        一貫性のあるユーザー体験を実現するためのデザインシステムは、以下の要素から構成されています。
      </p>
      <div className={styles.keyElements}>
        {props.KeyElementsItems.map((item, index) => (
          <section key={index} className={styles.keyElement}>
            <figure className={styles.keyElement__figure}>
              <img src={item.src} alt={item.title} />
            </figure>
            <div className={styles.keyElement__item}>
              <h4 className={styles.keyElement__item__title}>{item.title}</h4>
              <p className={styles.keyElement__item__text}>{item.description}</p>
            </div>
          </section>
        ))}
      </div>
    </section>
  )
}

export default KeyElements
